export default "__VITE_ASSET__9eKVlRwY__"